export default {
    getScenarios:      { method: 'get',    url: 'simulation-scenarios' },
    getScenario:       { method: 'get',    url: 'simulation-scenarios/{id}' },
    postScenario:      { method: 'post',   url: 'simulation-scenarios' },
    putScenario:       { method: 'put',    url: 'simulation-scenarios/{id}' },
    postBatch:         { method: 'post',   url: 'simulation-scenarios/batches' },
    deleteScenario:    { method: 'delete', url: 'simulation-scenarios/{id}' },
    getScenarioItems:  { method: 'get',    url: 'simulation-scenarios/{id}/items' },
    getItemsDistinct:  { method: 'get',    url: 'simulation-scenarios/{id}/items/distinct' },
    getBaseGroupStatus:{ method: 'get',    url: 'base_groups/status' },
    putScenarioItem:   { method: 'put',    url: 'simulation-scenarios/{id}/items/{itemId}' },
    bulkUpdateItems:   { method: 'put',    url: 'simulation-scenarios/{id}/items-bulk' },
    applyScenarioPreview: { method: 'get',  url: 'simulation-scenarios/{id}/apply/preview' },
    applyScenario:        { method: 'post', url: 'simulation-scenarios/{id}/apply' },
    getScenarioIndicators:{ method: 'get',  url: 'simulation-scenarios/{id}/indicators' },
}
